<template>
  <div>
    <div v-if="loading === true" class="tw-flex tw-gap-5">
      <base-skeleton-loader class="tw-h-9 tw-mb-0.5 tw-w-full" />
      <base-skeleton-loader class="tw-h-6 tw-w-7 tw-my-auto tw-rounded-full" />
      <base-skeleton-loader class="tw-h-6 tw-w-7 tw-my-auto tw-rounded-full" />
    </div>
    <div v-else class="tw-flex tw-gap-5">
      <base-text-field v-if="type === 'text-field'" :label="label" :size="size" v-model="value" class="tw-w-full" />
      <base-textarea v-else :label="label" :size="size" v-model="value" class="tw-w-full" :rows="6" />
      <base-icon :size="size" class="tw-my-auto" color="primary" :loading="isDeleting" @click="del()"><trash-icon class="tw-h-5 tw-w-5"/></base-icon>
      <base-icon :size="size" class="tw-my-auto" color="primary" :loading="isSaving" @click="save()"><save-icon class="tw-h-5 tw-w-5"/></base-icon>
    </div>
  </div>
</template>
<script>
import { SaveIcon, TrashIcon } from "@/assets/svgs";
export default {
  name: "TemplatSection",
  components: { SaveIcon, TrashIcon },
  props: {
    label: { type: String, require: true },
    templateName: { type: String, require: true },
    businessId: { type: String, require: true },
    section: { type: String, require: true },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["xs", "sm", "md", "lg", "xl"].indexOf(value) !== -1,
    },
    savedValue: String,
    loading: { type: Boolean, default: false },
    type: { type: String, default: "text-field", validator: (value) => ["text-field", "text-area"].indexOf(value) !== -1 },
  },
  data() {
    return {
      isSaving: false,
      isDeleting: false,
      value: null,
    };
  },
  watch: {
    savedValue(newValue) {
      this.value = newValue;
    },
  },
  methods: {
    save() {
      this.isSaving = true;
      this.$axios
        .post(`/admin/email/templates/${this.templateName}/business/${this.businessId}/section`, { section: this.section, value: this.value })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Content Saved", message: `The email content section was saved successfully.` });
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Failed to save content",
            message: "We had a problem saving this content.",
            error: err,
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    del() {
      this.isDeleting = true;
      this.$axios
        .delete(`/admin/email/templates/${this.templateName}/business/${this.businessId}/section/${this.section}`)
        .then(() => {
          this.$emit("deleted");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Content Deleted", message: `The email content section was saved successfully.` });
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Failed to delete content",
            message: "We had a problem deleting this content.",
            error: err,
          });
        })
        .finally(() => {
          this.isDeleting = false;
        });
    },
  },
};
</script>
